// @flow

// Mirrors Glassfrog::UrlField::ALLOWED_SCHEMES (app/lib/glassfrog/url_field.rb).
const ALLOWED_PROTOCOLS = [
  'http:', 'https:', 'mailto:', 'ftp:', 'file:', 'smb:',
  'ms-word:', 'ms-powerpoint:', 'ms-excel:', 'ms-visio:', 'ms-access:',
  'ms-project:', 'ms-publisher:', 'ms-spd:', 'ms-infopath:',
]

const sanitizeLinkUrl = (raw: ?string): ?string => {
  if (!raw)
    return null

  try {
    const {protocol} = new URL(raw)
    return ALLOWED_PROTOCOLS.includes(protocol) ? raw.trim() : null
  } catch (e) {
    return null
  }
}

export default sanitizeLinkUrl
